import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { StandardEvents } from '@shopify/events';

/**
 * Wings: the one-line fact under the price (one of one, ring size, made to your size).
 * Re-renders from the section HTML when the shopper picks another variant, like Atelier's inventory block.
 */
class WingsProductFact extends Component {
  connectedCallback() {
    super.connectedCallback();
    this.closest('.shopify-section, dialog')?.addEventListener(StandardEvents.productSelect, this.#onSelect);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    this.closest('.shopify-section, dialog')?.removeEventListener(StandardEvents.productSelect, this.#onSelect);
  }

  #onSelect = (event) => {
    if (!(event.target instanceof Element) || event.target.closest('product-card')) return;
    event.promise
      .then(({ detail }) => {
        if (!detail?.html) return;
        if (!detail.newProduct && detail.productId && detail.productId !== this.dataset.productId) return;
        const next = detail.html.querySelector(`wings-product-fact[data-block-id="${this.dataset.blockId}"]`);
        if (next) morph(this, next, { childrenOnly: true });
      })
      .catch((error) => {
        if (error?.name !== 'AbortError') console.warn('[wings-product-fact]', error);
      });
  };
}

if (!customElements.get('wings-product-fact')) customElements.define('wings-product-fact', WingsProductFact);
